import { useState, useEffect } from 'react';

interface ImageDebugInfoProps {
  images: Array<{
    id: number;
    url: string;
    alt?: string;
  }>;
  type: 'task' | 'signature';
}

const ImageDebugInfo: React.FC<ImageDebugInfoProps> = ({ images, type }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [imageLoadStatus, setImageLoadStatus] = useState<Record<string, 'loading' | 'success' | 'error'>>({});

  useEffect(() => {
    // Only show debug info on mobile devices
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);
    
    if (isMobile) {
      console.log(`${type} ImageDebugInfo: Mobile device detected`, {
        isAndroid,
        userAgent: navigator.userAgent,
        imageCount: images.length
      });
    }
  }, [images, type]);

  const handleImageLoad = (imageId: number, url: string) => {
    setImageLoadStatus(prev => ({
      ...prev,
      [imageId]: 'success'
    }));
    console.log(`${type} ImageDebugInfo: Image loaded successfully`, { imageId, url });
  };

  const handleImageError = (imageId: number, url: string) => {
    setImageLoadStatus(prev => ({
      ...prev,
      [imageId]: 'error'
    }));
    console.log(`${type} ImageDebugInfo: Image failed to load`, { imageId, url });
  };

  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);

  if (!isMobile || images.length === 0) {
    return null;
  }

  return (
    <div className="mb-2">
      {/* Debug toggle button */}
      <button
        onClick={() => setIsVisible(!isVisible)}
        className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded"
      >
        {isVisible ? 'Hide' : 'Show'} Debug Info ({type})
      </button>

      {/* Debug information */}
      {isVisible && (
        <div className="mt-2 p-2 bg-gray-100 dark:bg-gray-800 rounded text-xs">
          <div className="mb-2">
            <strong>Device Info:</strong>
            <div>Mobile: {isMobile ? 'Yes' : 'No'}</div>
            <div>Android: {isAndroid ? 'Yes' : 'No'}</div>
            <div>User Agent: {navigator.userAgent}</div>
          </div>
          
          <div className="mb-2">
            <strong>Images ({images.length}):</strong>
            {images.map((image, index) => (
              <div key={image.id} className="ml-2 mt-1">
                <div>ID: {image.id}</div>
                <div>URL: {image.url}</div>
                <div>Status: {imageLoadStatus[image.id] || 'loading'}</div>
                <div className="mt-1">
                  <img
                    src={image.url}
                    alt={image.alt || `Debug ${type} image ${index + 1}`}
                    className="max-w-20 max-h-20 object-contain border"
                    onLoad={() => handleImageLoad(image.id, image.url)}
                    onError={() => handleImageError(image.id, image.url)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageDebugInfo;
